import { queryOptions } from '@tanstack/react-query';
import { api } from '../../app/api-client';
import type { CityProviderLinkDto, PaymentProviderDto } from './schema';

export const paymentProvidersKey = ['admin', 'payment-providers'] as const;

export const listProvidersOptions = () =>
  queryOptions({
    queryKey: [...paymentProvidersKey, 'list'] as const,
    queryFn: () => api.get('admin/payments/providers').json<PaymentProviderDto[]>(),
    staleTime: 10_000,
  });

export const cityProviderLinksOptions = (cityId: string) =>
  queryOptions({
    queryKey: [...paymentProvidersKey, 'city-links', cityId] as const,
    queryFn: () =>
      api.get('admin/payments/city-links', { searchParams: { cityId } }).json<CityProviderLinkDto[]>(),
    enabled: Boolean(cityId),
  });
